'use strict';
(function () {
  var _controller = 'storeProductPersonalization.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', '$http', 'product.resource', 'additionalInformation.resource', 'promotion.resource', 'image.resource'];
  function controller($scope, $http, productResource, additionalInformationResource, promotionResource, imageResource) {
    /// Methods
    $scope.addToCart = addToCart;
    $scope.unselectOthers = unselectOthers;
    $scope.checkPersonalizations = checkPersonalizations;
    $scope.manualQuantity = manualQuantity;

    /// Vars
    var productId = appNavigator.topPage.data.productId;
    $scope.edit = appNavigator.topPage.data.product || null;
    $scope.quantity = 1;
    $scope.product;
    $scope.additionalInformationToShow = [];
    $scope.defaultRouterObject = $scope.$root.defaultRouter !== 'global' ? $scope.$root.routers.filter(function (f) { return f._id === $scope.$root.defaultRouter })[0] : $scope.$root.globalRouter;
    var hidePrices = $scope.$root.profile.enterprise && $scope.$root.profile.enterprise.pwaConfig && $scope.$root.profile.enterprise.pwaConfig.storeConfig && $scope.$root.profile.enterprise.pwaConfig.storeConfig.hidePrices
    $scope.readOnly = hidePrices || ($scope.defaultRouterObject.readOnlyStore && ($scope.$root.currentOrder.checkoutMethod === 'LOCAL' || $scope.$root.defaultRouter === 'global'));
    $scope.imageResource = imageResource;
    /// Watchers

    /// Init
    if (productId) getProduct();
    if (appNavigator.topPage.data && appNavigator.topPage.data.product) editProduct(appNavigator.topPage.data.product);

    /// Functiond
    function refreshPromotions() {
      if ($scope.$root.defaultRouter === 'global') return //- No aplican promociones a sucursal Global
      promotionResource.query({ _controller: _controller }, function (promotions) {
        window.setPromotionPrice($scope.product, promotions, $scope.$root.routers.find(function (r) { return r._id === $scope.$root.defaultRouter }));
      })
    }
    function getProduct() {
      productResource.query({
        _controller: _controller,
        checkoutMethod: $scope.$root.currentOrder.checkoutMethod,
        router: $scope.$root.defaultRouter,
        _select: ['properties.name', 'masterProduct', 'stamp']
      }, function (data) {
        $scope.products = data;
        data.forEach(function (e) {
          if (!e.masterProduct && !e.router) e.masterProduct = e._id; //- Esto sirve para Sucursal Global, para obtener la imagen del producto.
          if (!e._image) Object.defineProperty(e, '_image', { writable: true });
          e._image = '/progressiveApp/api/productMedia?product=' + e.masterProduct + '&enterprise=' + window.enterprise;
        })
        productResource.get({
          _controller: _controller,
          _id: productId,
          router: $scope.$root.defaultRouter,
          checkoutMethod: $scope.$root.currentOrder.checkoutMethod,
          _select: ['properties', 'masterProduct', 'stamp', 'additionalInformation']
        }, function (product) {
          if (!product.masterProduct && !product.router) product.masterProduct = product._id; //- Esto sirve para Sucursal Global, para obtener la imagen del producto.
          $scope.product = product;
          if ($scope.product.additionalInformation) {
            //la info adicional para mostrar se llama igual que la info adicional para completar, por eso se hizo esto
            $scope.product.additionalInformationToShow = $scope.product.additionalInformation;
            delete $scope.product.additionalInformation;
          }
          refreshPromotions();
          getAdditionalInformations();
          product.quantity = 1;
          if (!product._image) Object.defineProperty(product, '_image', { writable: true });
          checkImageExists(product);//- verifica si la imagen existe.
          if ($scope.product.properties.preparation) {
            $scope.product.properties.preparation = $scope.product.properties.preparation.filter(function (f) { return f.name !== 'Insumos' });
            $scope.product.properties.preparation.forEach(function (preparation) {
              if (preparation.requires && preparation.requires.length) preparation.requires.forEach(function (require) {
                if (require.products && require.products.length) require.products.forEach(function (p) {
                  p._originalSelected = p.selected;
                  p._originalQuantity = p.quantity;
                  p._hide = !$scope.products.filter(function (m) { return m.masterProduct === p._id }).length
                  require._targetQuantity = require.targetQuantity;
                  if (require.validation === 'FILL-TARGET') p.quantity = 0; //// No permito preset de sabores
                })
              })
            })
          }
        })
      })
    }

    function editProduct(product) {
      if (!product) return
      productResource.query({
        _controller: _controller,
        checkoutMethod: $scope.$root.currentOrder.checkoutMethod,
        router: $scope.$root.defaultRouter,
        _select: ['properties.name', 'masterProduct']
      }, function (data) {
        $scope.products = data;
        data.forEach(function (e) {
          if (!e.masterProduct && !e.router) e.masterProduct = e._id; //- Esto sirve para Sucursal Global, para obtener la imagen del producto.
          if (!e._image) Object.defineProperty(e, '_image', { writable: true });
          e._image = '/progressiveApp/api/productMedia?product=' + e.masterProduct + '&enterprise=' + window.enterprise;
        })
        $scope.product = product;
        if (!product._image) Object.defineProperty(product, '_image', { writable: true });
        checkImageExists(product);//- verifica si la imagen existe.
      })
    }

    function getAdditionalInformations() {
      $scope.product.additionalInformation = [];
      if (!$scope.product || !$scope.product.masterProduct) return;
      additionalInformationResource.query({ targets_in: ['STORE', 'PRODUCTS'], _controller: _controller }, function (ainfos) {
        $scope.additionalInformationToShow = ainfos.filter(function (ai) { return ai.targets.includes('PRODUCTS') });
        ainfos.forEach(function (ainfo) {
          if (!ainfo.products || !ainfo.products.length) return;
          if (ainfo.products.filter(function (f) { return f === $scope.product.masterProduct }).length)
            $scope.product.additionalInformation.push(ainfo);
        })
      })
    }


    var fail;
    function checkPersonalizations() {
      if (!$scope.product || !$scope.product.properties) return false;
      fail = false;

      //// AdditionalInformation
      if ($scope.product.additionalInformation && $scope.product.additionalInformation.length)
        $scope.product.additionalInformation.forEach(function (ainf) {
          if (!ainf.required) return;
          if (ainf && ainf.type === 'FILE' && !ainf.file) {
            ainf._missing = true;
            fail = true;
          }
          if (ainf && ainf.type === 'STRING' && !ainf.value) {
            ainf._missing = true;
            fail = true;
          }
        })
      if (fail) return fail;

      //// Personalizaciones
      if ($scope.product.properties.preparation && $scope.product.properties.preparation.length)
        $scope.product.properties.preparation.forEach(function (preparation) {
          if (Array.isArray(preparation.requires)) preparation.requires.forEach(function (requires) {
            if (!requires.mustChoose) return;
            var totalCount = 0;
            var ok = false;
            if (Array.isArray(requires.products)) requires.products.forEach(function (addProduct) {
              if (requires.validation === 'FILL-TARGET') totalCount += addProduct.quantity;
              else if (addProduct.selected) ok = true;
            })
            if (requires.validation === 'FILL-TARGET' && totalCount === requires.targetQuantity) ok = true;
            if (!ok) fail = true;
          })
        })
      if (fail) return fail;


      /// Seguir agregando debajo
    }

    function manualQuantity() {
      ons.notification.prompt({
        message: i18next.t('Ingrese la cantidad'),
        title: i18next.t('Cantidad manual'),
        inputType: 'number',
        cancelable: true
      }).then(function (val) {
        if (val) $scope.product.quantity = parseInt(val);
        if (!$scope.$$phase) $scope.$apply()
      })
    }

    function addToCart() {
      /// Marco los cambios hechos por el cliente
      if ($scope.product.properties.preparation.length)
        $scope.product.properties.preparation.forEach(function (preparation) {
          if (preparation.requires && preparation.requires.length) preparation.requires.forEach(function (require) {
            if (require.products && require.products.length) require.products.forEach(function (p) {
              p.modified = p._originalSelected !== p.selected || p._originalQuantity !== p.quantity;
            })
          })
        })
      if (productId) {
        $scope.product._new = true;
        $scope.product.frontendIndex = Date.now() + (Math.floor(Math.random() * 1000) / 1000);
        $scope.$root.currentOrder.products.push($scope.product)
        window.appNavigator.resetToPage('store/storeCart/storeCart.jade', { data: { onClose: Function.Prototype } });
      } else {
        var onClose = appNavigator.topPage.data && appNavigator.topPage.data.onClose;
        if (onClose) onClose();
        window.appNavigator.popPage();
      }
    }

    function unselectOthers(products, product) {
      products.forEach(function (p) { if (p !== product) p.selected = false })
    }

    function checkImageExists(product) {//- verifica si la imagen existe.
      if (!product.masterProduct) return product._image = undefined
      var ngSrc = '/progressiveApp/api/productMedia?product=' + product.masterProduct + '&enterprise=' + window.enterprise;
      var image = new Image();
      image.src = ngSrc;
      image.onload = function () { product._image = ngSrc; if (!$scope.$$phase) $scope.$apply() };
      image.onerror = function () { product._image = undefined };
    }
  }
})();
